import React from "react";
import { AlertTriangle, Flag, Clock, PauseCircle, PlayCircle, CheckCircle2, Circle } from "lucide-react";

export const STATUS_META = {
  "Not Started": { icon: Circle, tone: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-500/15 dark:text-slate-300 dark:border-slate-500/25", dot: "bg-slate-400" },
  "In Progress": { icon: PlayCircle, tone: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-500/15 dark:text-blue-300 dark:border-blue-500/25", dot: "bg-blue-500" },
  "Waiting for Client": { icon: PauseCircle, tone: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/25", dot: "bg-amber-500" },
  "Completed": { icon: CheckCircle2, tone: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/25", dot: "bg-emerald-500" },
  "Overdue": { icon: AlertTriangle, tone: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-500/15 dark:text-rose-300 dark:border-rose-500/25", dot: "bg-rose-500" },
};

export const TASK_STATUSES = ["Not Started", "In Progress", "Waiting for Client", "Completed"];

export const PRIORITY_META = {
  High: "bg-rose-50 text-rose-700 border-rose-100 dark:bg-rose-500/15 dark:text-rose-300 dark:border-rose-500/20",
  Medium: "bg-amber-50 text-amber-700 border-amber-100 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/20",
  Low: "bg-emerald-50 text-emerald-700 border-emerald-100 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/20",
};

export const StatusBadge = ({ status, className = "" }) => {
  const m = STATUS_META[status] || STATUS_META["Not Started"];
  const Icon = m.icon;
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold ${m.tone} ${className}`}>
      <Icon className="h-2.5 w-2.5" /> {status}
    </span>
  );
};

export const PriorityBadge = ({ priority }) => (
  <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold ${PRIORITY_META[priority] || ""}`}>
    <Flag className="h-2.5 w-2.5" /> {priority}
  </span>
);
